export function getDuplicateEmailAlertProps(duplicateEmailCheck, email) {
  return {
    accounts: duplicateEmailCheck.existingAccounts,
    email,
    hasPendingInvite: duplicateEmailCheck.showPendingInviteWarning,
  };
}

export function isRegistrationSubmitDisabled(
  loading,
  duplicateEmailCheck,
  extraDisabled = false
) {
  return loading || extraDisabled || duplicateEmailCheck.isRegistrationBlocked;
}

export function shouldClearDuplicateEmailCheck(duplicateEmailCheck) {
  return duplicateEmailCheck.isRegistrationBlocked;
}

export function registrationEmailBlurHandler(
  duplicateEmailCheck,
  validateEmail,
  email
) {
  return () => duplicateEmailCheck.checkEmailOnBlur(validateEmail, email);
}

export function clearRegistrationEmailOnChange(
  duplicateEmailCheck,
  fieldName,
  emailFieldName
) {
  if (fieldName === emailFieldName) {
    duplicateEmailCheck.clearIfBlocked();
  }
}
